import type { FC } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

import { Flex, Text } from '@highlight-cp/core-ui';

import classes from './impersonating-badge.module.css';

export interface ImpersonatingBadgeProps {
  /** Lets a neighbouring control point at this badge with `aria-describedby`. */
  id?: string;
}

/**
 * Says a Highlight employee — not the customer — is behind the screen. Sits
 * inside the avatar button, tucked under the avatar that overlaps its right end.
 */
const ImpersonatingBadge: FC<ImpersonatingBadgeProps> = ({ id }) => (
  <Flex
    align="center"
    justify="center"
    bg="var(--mantine-color-yellow-filled)"
    // Black rather than the inherited text colour, which flips light in dark mode
    // and loses contrast against the yellow fill.
    c="var(--mantine-color-black)"
    className={classes.badge}
    id={id}
    pl="xs"
    pr="xl"
    gap="xs"
    role="status"
  >
    <FiAlertTriangle size={16} aria-hidden />
    <Text size="sm" fw={600}>
      IMPERSONATING
    </Text>
  </Flex>
);

export default ImpersonatingBadge;
